<template>
  <div>
    <email-dialog
      :emails="emails"
      :dialog="emailDialog"
      :subject="emailSubject"
      :body="emailBody"
      @dialog-set="emailDialog = $event"
      @sendmail="sendEmail"
    />
    <v-dialog
      v-model="showChequeRequisitionForm"
      scrollable
      max-width="800"
      persistent
    >
      <cheque-requisition-form
        :option="option"
        v-on:save="showChequeRequisitionForm = false"
        v-on:cancel="
          option.IncludeChequeRequisition = false;
          showChequeRequisitionForm = false;
        "
        :dialog="showChequeRequisitionForm"
      />
    </v-dialog>
    <v-form ref="form">
      <v-row>
        <v-col
          cols="auto"
          v-show="
            calculationEntity === 'Billing' ||
            calculationEntity === 'Commissions'
              ? true
              : calculationEntity === null || calculationEntity === undefined
          "
        >
          <auto-select
            :disabled="
              calculationEntity === 'Billing' ||
              calculationEntity === 'Commissions'
                ? false
                : calculationEntity !== null && calculationEntity !== undefined
            "
            :value.sync="selectedReport"
            :items="reportOptions"
            :label="$t('components.getreports.select_report')"
            :rules="[$rules.required]"
            @change="
              payload.Options = [];
              selected.InsuranceCarriers = [];
              selected.Employers = [];
              selected.TrustFunds = [];
            "
            class="required"
            :slots="true"
            :filter="filterFunc"
          >
            <template v-slot:selection="data">
              {{ $t("components.getreports." + data.item) }}
            </template>
            <template v-slot:item="data">
              <v-list-item-content
                v-text="$t('components.getreports.' + data.item)"
              ></v-list-item-content>
            </template>
          </auto-select>
        </v-col>
        <v-col
          cols="auto"
          xs12
          sm6
          md4
          lg4
          v-if="selectedReport === 'Premiums'"
        >
          <trans-multi-select2
            v-model="selected.InsuranceCarriers"
            :items="insuranceCarriers"
            :label="$t('globals.insurance_carrier')"
            :rules="[$rules.required]"
            field="Name"
            itemValue="Id"
            :displayFunc="(item, str) => `${str} (${item.PolicyNumber})`"
            :canSelectAll="true"
            class="required"
          ></trans-multi-select2>
        </v-col>
        <v-col
          cols="auto"
          xs12
          sm6
          md4
          lg4
          v-if="
            selectedReport === 'Commissions' ||
            selectedReport === 'Commissions Enhanced' ||
            selectedReport === 'Commissions Recap Enhanced'
          "
        >
          <trans-multi-select2
            v-model="selected.Brokers"
            :items="brokers"
            :label="$t('components.getreports.brokers')"
            :rules="[$rules.required]"
            field="BrokerageName"
            itemValue="Id"
            :canSelectAll="true"
            class="required"
          ></trans-multi-select2>
        </v-col>
        <v-col cols="auto" xs12 sm6 md4 lg4 v-if="selectedReport === 'Billing'">
          <trans-multi-select2
            v-model="selected.Employers"
            :items="employers"
            :label="$t('globals.employers')"
            :rules="[$rules.required]"
            field="Name"
            itemValue="IdentityId"
            :canSelectAll="true"
            class="required"
          ></trans-multi-select2>
        </v-col>
        <v-col
          cols="auto"
          xs12
          sm6
          md4
          lg4
          v-if="selectedReport === 'Billing Enhanced'"
        >
          <trans-multi-select2
            v-model="selected.Employers"
            :items="employers"
            :label="$t('globals.employers')"
            :rules="[$rules.required]"
            field="Name"
            itemValue="IdentityId"
            :canSelectAll="true"
            class="required"
          ></trans-multi-select2>
        </v-col>
        <v-col
          cols="xs12 sm6"
          v-if="selectedReport === 'Billing' && stores.length > 0"
        >
          <trans-multi-select2
            :disabled="selected.Employers.length > 1"
            v-model="selected.Stores"
            :items="stores"
            :label="$t('globals.stores')"
            field="Name"
            itemValue="IdentityId"
            :canSelectAll="true"
          ></trans-multi-select2>
        </v-col>
        <v-col
          cols="xs12 sm6"
          v-if="selectedReport === 'Billing Enhanced' && stores.length > 0"
        >
          <trans-multi-select2
            :disabled="selected.Employers.length > 1"
            v-model="selected.Stores"
            :items="stores"
            :label="$t('globals.stores')"
            field="Name"
            itemValue="IdentityId"
            :canSelectAll="true"
          ></trans-multi-select2>
        </v-col>
        <v-col
          cols="auto"
          xs12
          sm6
          md4
          lg4
          v-if="selectedReport === 'Remittances'"
        >
          <trans-multi-select2
            v-model="selected.TrustFunds"
            :items="trustFunds"
            :label="$t('components.getreports.trust_fund')"
            field="Name"
            itemValue="Id"
            :canSelectAll="true"
          ></trans-multi-select2>
        </v-col>
        <v-col
          cols="auto"
          xs12
          sm6
          md4
          lg4
          v-if="coverageGroupItems && coverageGroupItems.length > 0"
        >
          <trans-multi-select2
            v-model="selected.CoverageGroups"
            :items="coverageGroupItems"
            :label="$t('components.getreports.coverage_groups')"
            field="Name"
            itemValue="Name"
            :canSelectAll="true"
          ></trans-multi-select2>
        </v-col>
        <template v-if="showPlanSummary()">
          <v-col cols="auto" class="align-self-center">
            <v-checkbox
              v-model="payload.IncludeTotal"
              :label="$t('components.getreports.include_plan_summary')"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="auto"
            class="align-self-center"
            v-if="
              selectedReport === 'Remittances' || selectedReport === 'Premiums'
            "
          >
            <v-checkbox
              v-model="payload.IncludeTotalWithoutTaxes"
              :label="
                $t('components.getreports.include_plan_summary_without_taxes')
              "
            ></v-checkbox>
          </v-col>
        </template>
        <v-col
          cols="auto"
          class="align-self-center"
          v-if="
            selectedReport === 'Commissions' ||
            selectedReport === 'Commissions Enhanced' ||
            selectedReport === 'Commissions Recap Enhanced'
          "
        >
          <v-checkbox
            v-model="payload.IncludeCommissionTotal"
            :label="$t('components.getreports.include_commission_total')"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <table class="report-options">
          <tr v-if="payload.Options && payload.Options.length > 1">
            <td class="align-self-center">
              <h2>{{ $t("globals.all") }}</h2>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                ((selectedReport !== 'Billing' &&
                  selectedReport !== 'Billing Enhanced') ||
                  payload.Options.some((item) => !item.EmployerHasStores)) &&
                (selectedReport !== 'Commissions' ||
                  selectedReport !== 'Commissions Enhanced' ||
                  selectedReport !== 'Commissions Recap Enhanced')
              "
            >
              <v-checkbox
                v-model="allCheckboxes.IncludeMemberDetails"
                :label="$t('components.getreports.include_member_details')"
                :indeterminate="
                  !allChecked('IncludeMemberDetails') &&
                  !allUnchecked('IncludeMemberDetails')
                "
                @change="applyToAll('IncludeMemberDetails')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                selectedReport === 'Billing' &&
                payload.Options.some((item) => !item.EmployerHasStores)
              "
            >
              <v-checkbox
                v-model="allCheckboxes.IncludeGroupSummary"
                :label="$t('components.getreports.include_group_summary')"
                :indeterminate="
                  !allChecked('IncludeGroupSummary') &&
                  !allUnchecked('IncludeGroupSummary')
                "
                @change="applyToAll('IncludeGroupSummary')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                selectedReport === 'Billing Enhanced' &&
                payload.Options.some((item) => !item.EmployerHasStores)
              "
            >
              <v-checkbox
                v-model="allCheckboxes.IncludeGroupSummary"
                :label="$t('components.getreports.include_group_summary')"
                :indeterminate="
                  !allChecked('IncludeGroupSummary') &&
                  !allUnchecked('IncludeGroupSummary')
                "
                @change="applyToAll('IncludeGroupSummary')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="selectedReport === 'Premiums'"
            >
              <v-checkbox
                v-model="allCheckboxes.IncludeGroupSummary"
                :label="
                  $t('components.getreports.include_coverage_summary_group')
                "
                :indeterminate="
                  !allChecked('IncludeGroupSummary') &&
                  !allUnchecked('IncludeGroupSummary')
                "
                @change="applyToAll('IncludeGroupSummary')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="payload.Options.some((item) => item.InsuranceCarrierId)"
            >
              <v-checkbox
                v-model="allCheckboxes.IncludeTotal"
                :label="$t('components.getreports.include_carrier_summary')"
                :indeterminate="
                  !allChecked('IncludeTotal') && !allUnchecked('IncludeTotal')
                "
                @change="applyToAll('IncludeTotal')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                payload.Options.some(
                  (item) => item.EmployerId && item.EmployerHasStores
                )
              "
            >
              <v-checkbox
                v-model="allCheckboxes.IncludeTotal"
                :label="$t('components.getreports.include_stores_summary')"
                :indeterminate="
                  !allChecked('IncludeTotal') && !allUnchecked('IncludeTotal')
                "
                @change="applyToAll('IncludeTotal')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="selectedReport === 'Remittances'"
            >
              <v-checkbox
                v-model="allCheckboxes.IncludeGroupSummary"
                :label="
                  $t('components.getreports.include_coverage_summary_group')
                "
                :indeterminate="
                  !allChecked('IncludeGroupSummary') &&
                  !allUnchecked('IncludeGroupSummary')
                "
                @change="applyToAll('IncludeGroupSummary')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="selectedReport === 'Remittances'"
            >
              <v-checkbox
                v-model="allCheckboxes.IncludeTotal"
                :label="$t('components.getreports.include_trustfund_total')"
                :indeterminate="
                  !allChecked('IncludeTotal') && !allUnchecked('IncludeTotal')
                "
                @change="applyToAll('IncludeTotal')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="selectedReport === 'Premiums'"
            >
              <!-- <v-checkbox
                v-model="allCheckboxes.IncludeChequeRequisition"
                :label="
                  $t(
                    'components.getreports.include_chequepayment_requisition_form'
                  )
                "
                @change="chequeChanged(item)"
              ></v-checkbox> -->
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                selectedReport === 'Commissions' ||
                selectedReport === 'Commissions Enhanced' ||
                selectedReport === 'Commissions Recap Enhanced'
              "
            >
              <v-checkbox
                v-model="allCheckboxes.IncludeCommissionSummary"
                :label="$t('components.getreports.include_commission_summary')"
                :indeterminate="
                  !allChecked('IncludeCommissionSummary') &&
                  !allUnchecked('IncludeCommissionSummary')
                "
                @change="applyToAll('IncludeCommissionSummary')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                selectedReport === 'Commissions' ||
                selectedReport === 'Commissions Enhanced' ||
                selectedReport === 'Commissions Recap Enhanced'
              "
            >
              <v-checkbox
                v-model="allCheckboxes.IncludeCommissionDetails"
                :label="$t('components.getreports.include_commission_details')"
                :indeterminate="
                  !allChecked('IncludeCommissionDetails') &&
                  !allUnchecked('IncludeCommissionDetails')
                "
                @change="applyToAll('IncludeCommissionDetails')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                selectedReport === 'Commissions' ||
                selectedReport === 'Commissions Enhanced' ||
                selectedReport === 'Commissions Recap Enhanced'
              "
            >
              <v-checkbox
                v-model="allCheckboxes.IncludeFlatFees"
                :label="$t('components.getreports.include_flat_fees')"
                :indeterminate="
                  !allChecked('IncludeFlatFees') &&
                  !allUnchecked('IncludeFlatFees')
                "
                @change="applyToAll('IncludeFlatFees')"
              ></v-checkbox>
            </td>
          </tr>
          <tr v-for="(item, i) in payload.Options" :key="i">
            <td class="align-self-center">
              <h2>{{ item.Name }}</h2>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                ((selectedReport !== 'Billing' &&
                  selectedReport !== 'Billing Enhanced') ||
                  !item.EmployerHasStores) &&
                (selectedReport !== 'Commissions' ||
                  selectedReport !== 'Commissions Enhanced' ||
                  selectedReport !== 'Commissions Recap Enhanced')
              "
            >
              <v-checkbox
                v-model="item.IncludeMemberDetails"
                :label="$t('components.getreports.include_member_details')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="selectedReport === 'Billing' && !item.EmployerHasStores"
            >
              <v-checkbox
                v-model="item.IncludeGroupSummary"
                :label="$t('components.getreports.include_group_summary')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                selectedReport === 'Billing Enhanced' && !item.EmployerHasStores
              "
            >
              <v-checkbox
                v-model="item.IncludeGroupSummary"
                :label="$t('components.getreports.include_group_summary')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="selectedReport === 'Premiums'"
            >
              <v-checkbox
                v-model="item.IncludeGroupSummary"
                :label="
                  $t('components.getreports.include_coverage_summary_group')
                "
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="item.InsuranceCarrierId"
            >
              <v-checkbox
                v-model="item.IncludeTotal"
                :label="$t('components.getreports.include_carrier_summary')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="item.EmployerId && item.EmployerHasStores"
            >
              <v-checkbox
                v-model="item.IncludeTotal"
                :label="$t('components.getreports.include_stores_summary')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="selectedReport === 'Remittances'"
            >
              <v-checkbox
                v-model="item.IncludeGroupSummary"
                :label="
                  $t('components.getreports.include_coverage_summary_group')
                "
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="selectedReport === 'Remittances'"
            >
              <v-checkbox
                v-model="item.IncludeTotal"
                :label="$t('components.getreports.include_trustfund_total')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="selectedReport === 'Premiums'"
            >
              <v-checkbox
                v-model="item.IncludeChequeRequisition"
                :label="
                  $t(
                    'components.getreports.include_chequepayment_requisition_form'
                  )
                "
                @change="chequeChanged(item)"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                selectedReport === 'Commissions' ||
                selectedReport === 'Commissions Enhanced' ||
                selectedReport === 'Commissions Recap Enhanced'
              "
            >
              <v-checkbox
                v-model="item.IncludeCommissionSummary"
                :label="$t('components.getreports.include_commission_summary')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                selectedReport === 'Commissions' ||
                selectedReport === 'Commissions Enhanced' ||
                selectedReport === 'Commissions Recap Enhanced'
              "
            >
              <v-checkbox
                v-model="item.IncludeCommissionDetails"
                :label="$t('components.getreports.include_commission_details')"
              ></v-checkbox>
            </td>
            <td
              cols="auto"
              class="align-self-center"
              v-if="
                selectedReport === 'Commissions' ||
                selectedReport === 'Commissions Enhanced' ||
                selectedReport === 'Commissions Recap Enhanced'
              "
            >
              <v-checkbox
                v-model="item.IncludeFlatFees"
                :label="$t('components.getreports.include_flat_fees')"
              ></v-checkbox>
            </td>
          </tr>
        </table>
      </v-row>
      <v-row>
        <v-col cols="auto" class="align-self-center">
          <v-btn
            :disabled="!reportSelectionValid || autoloading"
            :loading="loading"
            dark
            color="primary"
            @click="tryGetReport()"
          >
            {{ $t("components.getreports.get") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <div v-if="showReport" id="report-div">
      <v-divider></v-divider>
      <div style="margin-top: 10px">
        <v-flex>
          <v-menu>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="success" dark style="margin-right: 10px">
                <v-icon>file_download</v-icon>
                {{ $t("globals.download") }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="downloadExcel()">
                <v-list-item-title>
                  {{ $t("components.getreports.excel") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadPdf()">
                <v-list-item-title>
                  {{ $t("components.getreports.pdf") }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            color="primary"
            dark
            @click="emailDialog = true"
            style="margin-right: 10px"
          >
            <v-icon>email</v-icon>
            {{ $t("globals.send") }}
          </v-btn>
        </v-flex>
      </div>
      <v-row>
        <v-col sm12>
          <iframe
            :src="pdfFileLink"
            style="height: 500px; width: 100%; border: none"
          ></iframe>
        </v-col>
      </v-row>
    </div>
    <v-snackbar
      v-model="mailAlert.show"
      :bottom="true"
      :color="mailAlert.type"
      :multi-line="true"
      :timeout="6000"
    >
      {{ mailAlert.text }}
      <v-btn dark text @click="mailAlert.show = false">X</v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import EmailDialog from "../components/EmailDialog";
import ChequeRequisitionForm from "../components/ChequeRequisitionForm";
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import TransMultiSelect2 from "../components/TransMultiSelect2";
import { translate2 } from "../trans2";
import AutoSelect from "../components/AutoSelect";
import { sortAlphanum } from "../alphanumericSort";

export default {
  name: "get-reports",
  components: {
    EmailDialog,
    ChequeRequisitionForm,
    ErrorHandler,
    TransMultiSelect2,
    AutoSelect,
  },
  props: [
    "calculationEntity",
    "term",
    "reportId",
    "isRecap",
    "hasEnhancedBillingReport",
  ],
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("auth", ["user"]),
    ...mapGetters("common", {
      selectedPlan: "plan",
      settings: "settings",
      brokerId: "brokerId",
    }),
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", { planParameters: "planOptions" }),
  },
  data() {
    return {
      allCheckboxes: {
        IncludeMemberDetails: false,
        IncludeGroupSummary: false,
        IncludeTotal: false,
        IncludeCommissionSummary: false,
        IncludeCommissionDetails: false,
        IncludeFlatFees: false,
      },
      sameIC: false,
      autoloading: false,
      broker: null,
      error: null,
      pdfFileLink: null,
      numPages: 0,
      option: null,
      showChequeRequisitionForm: false,
      payload: { Options: [], IncludeTotal: true },
      file: null,
      emails: [],
      emailSubject: "",
      emailBody: "",
      contacts: [],
      emailDialog: false,
      showReport: false,
      loading: false,
      reportSelectionValid: false,
      insuranceCarriers: [],
      brokers: [],
      employers: [],
      selected: {
        Employers: [],
        TrustFunds: [],
        Stores: [],
        InsuranceCarriers: [],
        CoverageGroups: [],
        Brokers: [],
      },
      stores: [],
      trustFunds: [],
      coverageGroupItems: [],
      coverageGroups: [],
      mailAlert: {
        show: false,
      },
      reportOptions: [],
      selectedReport: null,
      valid: true,
      userInfo: null,
    };
  },
  watch: {
    term: {
      immediate: true,
      async handler() {
        this.trustFunds = [];
        this.insuranceCarriers = [];
        this.employers = [];
        this.coverageGroups = [];
        this.brokers = [];
        this.loadData();
      },
    },
    selectedReport: {
      async handler(v) {
        if (v) {
          this.selectAll();
        } else {
          this.reportSelectionValid = false;
        }
      },
      deep: true,
    },
    "selected.Employers": {
      async handler(v) {
        this.autoloading = true;
        if (v && v.length > 0) {
          let allStores = [];
          if (this.planParameters.ReportsPerStore) {
            for (let employer of v) {
              let stores = (
                await this.getReportEmployerStores({
                  planId: this.selectedPlan.Id,
                  reportId: this.reportId,
                  employerId: employer.IdentityId,
                })
              ).data.value;

              const collator = new Intl.Collator(undefined, {
                numeric: true,
                sensitivity: "base",
              });
              if (stores.length > 0) {
                allStores = allStores.concat(stores.sort(collator.compare));
              }
            }
          }
          await this.mapEmployersToPayloadOptions(v);
          await this.getCoverageGroups();
          this.stores = allStores;
          this.selected.Stores = this.stores;
        } else {
          this.coverageGroupItems = [];
          this.stores = [];
          await this.mapEmployersToPayloadOptions(v);
        }
        this.autoloading = false;
      },
      deep: true,
    },
    "selected.Stores": {
      async handler(v, old) {
        this.autoloading = true;
        await this.mapStoresToPayloadOptions(v, old);
        this.autoloading = false;
      },
      deep: true,
    },
    "selected.InsuranceCarriers": {
      async handler(v) {
        this.autoloading = true;
        if (v && v.length > 0) {
          const d = new Date();
          this.payload.Options = v.map((i) => {
            return {
              DateOfRequest: this.toUtcString(d),
              Name: translate2(i, "Name"),
              InsuranceCarrierName: translate2(i, "Name"),
              InsuranceCarrierId: i.Id,
              User: this.user,
              IncludeMemberDetails: true,
              IncludeGroupSummary: true,
              IncludeTotal: true,
              IncludeChequeRequisition: true,
            };
          });
          await this.getCoverageGroups();
          var ic = [...new Set(v.map((o) => o.InsuranceCarrierId))];
          if (ic.length === 1) {
            this.applyDefaultsIC();
            this.sameIC = true;
          } else {
            this.payload.IncludeTotal = true;
            this.payload.IncludeTotalWithoutTaxes = false;
            this.sameIC = false;
            console.log("#######################");
          }
        } else {
          this.payload.IncludeTotal = false;
          this.payload.IncludeTotalWithoutTaxes = false;
          this.coverageGroupItems = [];
          this.payload.Options = [];
          this.sameIC = false;
          console.log("#######################$$$$$$$$$$$$$$$$$");
        }
        this.autoloading = false;
      },
      deep: true,
    },
    "selected.TrustFunds": {
      async handler(v) {
        this.autoloading = true;
        if (v) {
          this.payload.Options = v.map((i) => {
            return {
              Name: translate2(i, "Name"),
              TrustfundId: i.Id,
              User: this.user,
              IncludeMemberDetails: true,
              IncludeGroupSummary: true,
              IncludeTotal: true,
            };
          });
          await this.getCoverageGroups();
        } else {
          this.coverageGroupItems = [];
          this.payload.Options = [];
        }
        this.autoloading = false;
      },
      deep: true,
    },
    "selected.CoverageGroups": {
      handler(v) {
        this.reportSelectionValid = this.checkForValidReportSelection();
      },
      deep: true,
    },
    "selected.Brokers": {
      async handler(v) {
        this.autoloading = true;
        if (v && v.length > 0) {
          const d = new Date();
          this.payload.Options = v.map((i) => {
            return {
              DateOfRequest: this.toUtcString(d),
              BrokerId: i.Id,
              User: this.user,
              IncludeCommissionSummary: true,
              IncludeCommissionDetails: true,
              IncludeFlatFees: true,
            };
          });
          this.coverageGroupItems = [];
        } else {
          this.coverageGroupItems = [];
          this.payload.Options = [];
        }
        this.autoloading = false;
      },
      deep: true,
    },
    coverageGroups: {
      handler(v) {
        this.coverageGroupItems = v.map((cg) => {
          return { Name: cg };
        });
      },
      deep: true,
    },
    contacts: {
      handler(c) {
        var groupedEmails = [];
        var inHouse = [];
        var external = [];
        for (var i = 0; i < c.length; i++) {
          if (c[i].IsInHouse) {
            inHouse.push({
              name: c[i].Name,
              email: c[i].Email,
              group: "In House",
            });
          } else {
            external.push({
              name: c[i].Name,
              email: c[i].Email,
              group: "External",
            });
          }
        }
        if (inHouse.length > 0) {
          groupedEmails.push({ header: "In House" });
          groupedEmails = groupedEmails.concat(inHouse);
        }
        if (external.length > 0) {
          groupedEmails.push({ header: "External" });
          groupedEmails = groupedEmails.concat(external);
        }
        this.emails = groupedEmails;
      },
    },
    payload: {
      handler(v) {
        console.log("payload-change: ", JSON.stringify(v));
        this.reportSelectionValid = this.checkForValidReportSelection();
      },
      deep: true,
    },
    "payload.Options": {
      handler(v) {
        console.log("payload-options-change: ", v);
        this.checkForAllCheckBoxes();
      },
      deep: true,
    },
  },
  async mounted() {
    try {
      this.broker = (
        await this.getOrganizationById({
          id: this.brokerId,
        })
      ).data;
      await this.loadData();
      if (
        this.calculationEntity !== null &&
        this.calculationEntity !== undefined
      ) {
        this.selectedReport = this.calculationEntity;
      } else if (this.reportOptions.length > 0) {
        this.selectedReport = this.reportOptions[0];
      } else {
        this.selectedReport = null;
      }
      this.selectAll();
    } catch (error) {
      this.error = error;
    }
  },
  methods: {
    ...mapActions("data", ["fetchFile"]),
    ...mapActions("plansMembers", [
      "getInsuranceCarriersWithReports",
      "getReportTrustFund",
      "getEmployersWithReports",
      "getContacts",
      "getStores",
      "getReportEmployerStores",
      "getOrganizationById",
      "getBrokersWithReports",
    ]),
    ...mapActions("transactions", [
      "sendReportEmail",
      "getReport",
      "getInsuranceCarrierCoverageGroups",
      "getTrustfundCoverageGroups",
      "getPlanCoverageGroups",
    ]),
    checkForAllCheckBoxes() {
      console.log("check-for-all");
      if (this.allChecked("IncludeMemberDetails")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeMemberDetails = true;
          this.$forceUpdate();
        });
      } else if (this.allUnchecked("IncludeMemberDetails")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeMemberDetails = false;
          this.$forceUpdate();
        });
      }
      if (this.allChecked("IncludeGroupSummary")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeGroupSummary = true;
          this.$forceUpdate();
        });
      } else if (this.allUnchecked("IncludeGroupSummary")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeGroupSummary = false;
          this.$forceUpdate();
        });
      }
      if (this.allChecked("IncludeTotal")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeTotal = true;
          this.$forceUpdate();
        });
      } else if (this.allUnchecked("IncludeTotal")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeTotal = false;
          this.$forceUpdate();
        });
      }
      if (this.allChecked("IncludeCommissionSummary")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeCommissionSummary = true;
          this.$forceUpdate();
        });
      } else if (this.allUnchecked("IncludeCommissionSummary")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeCommissionSummary = false;
          this.$forceUpdate();
        });
      }
      if (this.allChecked("IncludeCommissionDetails")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeCommissionDetails = true;
          this.$forceUpdate();
        });
      } else if (this.allUnchecked("IncludeCommissionDetails")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeCommissionDetails = false;
          this.$forceUpdate();
        });
      }
      if (this.allChecked("IncludeFlatFees")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeFlatFees = true;
          this.$forceUpdate();
        });
      } else if (this.allUnchecked("IncludeFlatFees")) {
        this.$nextTick(() => {
          this.allCheckboxes.IncludeFlatFees = false;
          this.$forceUpdate();
        });
      }
    },
    allChecked(propertyName) {
      var ret = this.payload.Options.every((o) => o[propertyName] === true);
      console.log("all-checked: ", propertyName, ret);
      return ret;
    },
    allUnchecked(propertyName) {
      var ret = this.payload.Options.every((o) => o[propertyName] === false);
      console.log("all-unchecked: ", propertyName, ret);
      return ret;
    },
    applyToAll(propertyName) {
      var value = this.payload.Options.some((o) => o[propertyName] === true);
      console.log("apply-to-all: ", propertyName, value);
      for (let item of this.payload.Options) {
        item[propertyName] = !value;
      }
    },
    applyDefaultsIC() {
      this.payload.IncludeTotalWithoutTaxes =
        this.selected.InsuranceCarriers[0].TotalWithoutTaxes;
      this.payload.IncludeTotal =
        this.selected.InsuranceCarriers[0].TotalWithTaxes;
    },
    filterFunc(item, search) {
      return (
        this.$t("components.getreports." + item)
          .toLowerCase()
          .indexOf(search.toLowerCase()) > -1
      );
    },
    async loadData() {
      if (
        this.calculationEntity === "Premiums" ||
        this.calculationEntity === null ||
        this.calculationEntity === undefined
      ) {
        if (this.planParameters.HasPremiums) {
          try {
            this.insuranceCarriers = (
              await this.getInsuranceCarriersWithReports({
                planId: this.selectedPlan.Id,
                reportId: this.reportId,
              })
            ).data;
            this.reportOptions.push("Premiums");
          } catch (error) {
            error.messageParams = ["Premiums"];
            this.error = error;
          }
        }
      }
      if (
        this.calculationEntity === "Billing" ||
        this.calculationEntity === null ||
        this.calculationEntity === undefined
      ) {
        if (this.planParameters.HasBilling) {
          try {
            // const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
            this.employers = (
              await this.getEmployersWithReports({
                planId: this.selectedPlan.Id,
                reportId: this.reportId,
              })
            ).data.value.sort((a, b) => {
              const translatedA = a.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
              const translatedB = b.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
              console.log(translatedA, translatedB);
              return sortAlphanum(translatedA, translatedB);
            });

            this.reportOptions.push("Billing");
            if (this.hasEnhancedBillingReport) {
              this.reportOptions.push("Billing Enhanced");
            }
          } catch (error) {
            error.messageParams = ["Billing"];
            this.error = error;
          }
        }
      }
      if (
        this.calculationEntity === "Remittances" ||
        this.calculationEntity === null ||
        this.calculationEntity === undefined
      ) {
        if (this.planParameters.HasRemittances) {
          try {
            this.trustFunds = [
              (
                await this.getReportTrustFund({
                  planId: this.selectedPlan.Id,
                  reportId: this.reportId,
                })
              ).data,
            ];
            this.reportOptions.push("Remittances");
          } catch (error) {
            error.messageParams = ["Remittances"];
            this.error = error;
          }
        }
      }
      if (
        this.calculationEntity === null ||
        this.calculationEntity === undefined ||
        this.calculationEntity.toLowerCase().indexOf("commission") > -1
      ) {
        if (this.planParameters.HasCommissions) {
          try {
            this.brokers = (
              await this.getBrokersWithReports({
                planId: this.selectedPlan.Id,
                reportId: this.reportId,
              })
            ).data;

            if (this.isRecap) {
              this.reportOptions.push("Commissions Recap Enhanced");
            } else {
              // this.reportOptions.push("Commissions");
              this.reportOptions.push("Commissions Enhanced");
            }
          } catch (error) {
            error.messageParams = ["Commissions"];
            this.error = error;
          }
        }
      }
    },
    selectAll() {
      if (this.selectedReport === "Premiums") {
        if (this.insuranceCarriers.length > 0) {
          this.$nextTick(() => {
            this.selected.InsuranceCarriers = [this.insuranceCarriers[0]];
          });
        }
      } else if (this.selectedReport === "Billing") {
        if (this.employers.length > 0) {
          this.$nextTick(() => {
            this.selected.Employers = [this.employers[0]];
          });
        }
      } else if (this.selectedReport === "Billing Enhanced") {
        if (this.employers.length > 0) {
          this.$nextTick(() => {
            this.selected.Employers = [this.employers[0]];
          });
        }
      } else if (this.selectedReport === "Remittances") {
        if (this.trustFunds.length > 0) {
          this.$nextTick(() => {
            this.selected.TrustFunds = [this.trustFunds[0]];
          });
        }
      } else if (
        this.selectedReport === "Commissions" ||
        this.selectedReport === "Commissions Enhanced" ||
        this.selectedReport === "Commissions Recap Enhanced"
      ) {
        this.payload.IncludeCommissionTotal = true;
        if (this.brokers.length > 0) {
          this.$nextTick(() => {
            this.selected.Brokers = [this.brokers[0]];
          });
        }
      }
    },
    showPlanSummary() {
      switch (this.selectedReport) {
        case "Premiums":
          return this.insuranceCarriers && this.insuranceCarriers.length > 1;
        case "Billing":
          return this.employers && this.employers.length > 0;
        case "Billing Enhanced":
          return this.employers && this.employers.length > 0;
        case "Remittances":
          return this.trustFunds && this.trustFunds.length > 1;
        case "Commissions":
          return false;
        case "Commissions Enhanced":
          return false;
        case "Commissions Recap Enhanced":
          return false;
      }
    },
    toUtcString(date) {
      const utcString =
        date.getFullYear() +
        "-" +
        this.getMonth(date) +
        "-" +
        this.getDate(date) +
        "T00:00:00.0Z";
      return utcString;
    },
    getMonth(date) {
      let month = (date.getMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      return month;
    },
    getDate(date) {
      let d = date.getDate().toString();
      if (d.length === 1) {
        d = "0" + d;
      }
      return d;
    },
    async mapEmployersToPayloadOptions(v) {
      // this.payload.Options = [];
      let payloadOptions = [];
      for (const i of v) {
        let stores = (
          await this.getReportEmployerStores({
            planId: this.selectedPlan.Id,
            reportId: this.reportId,
            employerId: i.IdentityId,
          })
        ).data.value;
        var employerHasStores =
          this.planParameters.ReportsPerStore && stores
            ? stores.length > 0
            : false;
        if (
          payloadOptions.filter((o) => o.EmployerId === i.IdentityId).length ===
          0
        ) {
          payloadOptions.push({
            Name: translate2(i, "Name"),
            EmployerId: i.IdentityId,
            User: this.user,
            EmployerHasStores: employerHasStores,
          });
          if (employerHasStores) {
            payloadOptions[payloadOptions.length - 1].IncludeTotal = true;
          } else {
            payloadOptions[
              payloadOptions.length - 1
            ].IncludeGroupSummary = true;
            payloadOptions[
              payloadOptions.length - 1
            ].IncludeMemberDetails = true;
          }
        }
      }
      let allCheckboxesIncludeMemberDetails = true;
      let allCheckboxesIncludeGroupSummary = true;
      let allCheckboxesIncludeTotal = true;
      for (let option of payloadOptions) {
        allCheckboxesIncludeMemberDetails =
          allCheckboxesIncludeMemberDetails && !!option.IncludeMemberDetails;
        allCheckboxesIncludeGroupSummary =
          allCheckboxesIncludeGroupSummary && !!option.IncludeGroupSummary;
        allCheckboxesIncludeTotal =
          allCheckboxesIncludeTotal && !!option.IncludeTotal;
      }
      this.payload.Options = payloadOptions;
      // console.log(JSON.stringify(this.allCheckboxes));
      console.log(allCheckboxesIncludeMemberDetails);
      console.log(allCheckboxesIncludeGroupSummary);
      console.log(allCheckboxesIncludeTotal);
      if (allCheckboxesIncludeMemberDetails === true) {
        this.allCheckboxes.IncludeMemberDetails = true;
      }
      if (allCheckboxesIncludeGroupSummary === true) {
        this.allCheckboxes.IncludeGroupSummary = true;
      }
      if (allCheckboxesIncludeTotal === true) {
        this.allCheckboxes.IncludeTotal = true;
      }
      if (v.length === 0) {
        this.selected.Stores = [];
      }
      console.log(JSON.stringify(this.allCheckboxes));
    },
    async mapStoresToPayloadOptions(v, old) {
      if (v && v.length > 0) {
        const options = v.map((i) => {
          return {
            Name: translate2(i, "Name"),
            StoreId: i.IdentityId,
            User: this.user,
            IncludeMemberDetails: true,
            IncludeGroupSummary: true,
          };
        });
        await this.mapEmployersToPayloadOptions(this.selected.Employers);
        this.payload.Options = this.payload.Options.concat(options);
      } else {
        if (old.length > 0 && v.length === 0) {
          await this.mapEmployersToPayloadOptions(this.selected.Employers);
        }
      }
    },
    printElement() {
      let pdfUrl = this.settings.APIURL + "pdfs/" + this.file.PDFName;
    },
    chequeChanged(item) {
      this.option = item;
      this.showChequeRequisitionForm = item.IncludeChequeRequisition;
    },
    reset() {
      this.selectedReport = null;
      this.selected.InsuranceCarriers = [];
      this.selected.TrustFunds = [];
      this.selected.Employers = [];
      this.selected.Stores = [];
      this.selectedBrokers = [];
      this.includeTotal = false;
      this.$refs.form.resetValidation();
      this.showReport = false;
    },
    displayAddress(obj) {
      let res = "";

      if (obj.SuiteNumber) {
        res += obj.SuiteNumber;
      }
      if (obj.StreetNumber) {
        if (res.length > 0) {
          res += ", ";
        }
        res += obj.StreetNumber.toString();
      }
      if (obj.StreetName) {
        if (res.length > 0) {
          res += ", ";
        }
        res += obj.StreetName;
      }
      if (res.length > 0) {
        res += ", ";
      }
      res += obj.City + ", " + obj.Province.Code;
      if (obj.PostalCode) {
        res += " " + obj.PostalCode;
      }
      return res;
    },
    async tryGetReport() {
      this.showReport = false;
      this.loading = true;
      this.emailSubject = this.$t(
        "components.getreports.email_subject_{0}_{1}_{2}",
        [
          translate2(this.selectedPlan, "Name"),
          this.$t(this.selectedReport),
          translate2(this.term, "Name"),
        ]
      );

      let reportSelections = this.getReportsSelections();
      let trans = reportSelections.map((s) => translate2(s, "Name"));
      if (
        this.selectedReport === "Commissions" ||
        this.selectedReport === "Commissions Enhanced" ||
        this.selectedReport === "Commissions Recap Enhanced"
      ) {
        trans = reportSelections.map((s) => translate2(s, "BrokerageName"));
      }
      let selectionsStr = trans.join(", ");
      if (this.selectedReport === "Billing") {
        if (this.selected.Stores && this.selected.Stores.length > 0) {
          selectionsStr = this.selected.Employers.map(
            (s) =>
              `${translate2(s, "Name")} - ${this.selected.Stores.map((o) =>
                translate2(o, "Name")
              ).join(", ")}`
          ).join("\n");
        }
      }
      if (this.selectedReport === "Billing Enhanced") {
        if (this.selected.Stores && this.selected.Stores.length > 0) {
          selectionsStr = this.selected.Employers.map(
            (s) =>
              `${translate2(s, "Name")} - ${this.selected.Stores.map((o) =>
                translate2(o, "Name")
              ).join(", ")}`
          ).join("\n");
        }
      }

      this.emailBody = [
        this.$t("globals.hello"),
        this.$t("components.getreports.email_body_{0}_{1}_{2}_{3}", [
          this.$t(this.selectedReport),
          translate2(this.selectedPlan, "Name"),
          selectionsStr,
          translate2(this.term, "Name"),
        ]),
        "Kind regards,",
        this.broker.Name,
        this.displayAddress(this.broker),
        this.broker.Email,
      ].join("\n");

      try {
        if (
          this.selectedReport !== "Commissions" &&
          this.selectedReport !== "Commissions Enhanced" &&
          this.selectedReport !== "Commissions Recap Enhanced"
        ) {
          await this.getPotentialContacts();
        }
        this.payload.PlanId = this.selectedPlan.Id;
        this.payload.TermId = this.term.Id;
        this.payload.HasAdminFees = this.planParameters.HasAdminFees;
        this.payload.HasCommissions = this.planParameters.HasCommissions;
        this.payload.HasContributions = this.planParameters.HasContributions;
        this.payload.HasPaymentTracking =
          this.planParameters.HasPaymentTracking;
        this.payload.HasRemittances = this.planParameters.HasRemittances;
        this.payload.TracksMembersActivity =
          this.planParameters.TracksMembersActivity;
        this.payload.CoverageGroups = this.selected.CoverageGroups.map(
          (scg) => {
            return scg.Name;
          }
        );
        this.payload["ReportType"] = this.selectedReport;
        this.payload.ReportId = this.reportId;
        this.file = (
          await this.getReport({
            entity: this.selectedReport.toLowerCase(),
            payload: this.payload,
          })
        ).data;
        this.showReport = true;
        this.pdfFileLink = this.settings.APIURL + "pdfs/" + this.file.PDFName;
        setTimeout(() => {
          document.getElementById("report-div").scrollIntoView({
            behavior: "smooth",
          });
        }, 750);
      } catch (error) {
        error.messageParams = [this.selectedReport];
        this.error = error;
      }
      this.loading = false;
    },
    async getPotentialContacts() {
      try {
        this.contacts = (
          await this.getContacts({
            planId: this.selectedPlan.Id,
            filter:
              "(" + this.createContactsFilter() + ") or IsInhouse eq true",
          })
        ).data.value;
      } catch (error) {
        this.error = error;
      }
    },
    createContactsFilter() {
      switch (this.selectedReport) {
        case "Premiums":
          return this.selected.InsuranceCarriers.map(
            (item) => "PlanInsuranceCarrierId eq " + item.Id
          ).join(" or ");
        case "Billing":
          return this.selected.Employers.map(
            (item) => "EmployerId eq " + item.IdentityId
          ).join(" or ");
        case "Billing Enhanced":
          return this.selected.Employers.map(
            (item) => "EmployerId eq " + item.IdentityId
          ).join(" or ");
        case "Remittances":
          return this.selected.TrustFunds.map(
            (item) => "TrustFundId eq " + item.Id
          ).join(" or ");
      }
    },
    async sendEmail({ email, attachments }) {
      email.sender = this.user;
      email.urls = [];
      email.filenames = [];

      if (attachments.indexOf("Pdf") > -1) {
        email.filenames.push(this.file.PDFName);
        email.urls.push(this.settings.APIURL + "pdfs/" + this.file.PDFName);
      }

      if (attachments.indexOf("Excel") > -1) {
        email.filenames.push(this.file.ExcelName);
        email.urls.push(this.settings.APIURL + "excels/" + this.file.ExcelName);
      }
      var that = this;
      try {
        await this.sendReportEmail(email);
        that.mailAlert.show = true;
        that.mailAlert.type = "success";
        that.mailAlert.text = this.$t("components.getreports.email_success");
      } catch (error) {
        error.clientCode = "getReportsMail";
        this.error = error;
      }
    },
    checkForValidReportSelection() {
      console.log("check-valid");
      this.checkForAllCheckBoxes();
      var selections = this.getReportsSelections();
      let valid = selections ? selections.length > 0 : false;
      if (this.coverageGroupItems.length > 0) {
        valid = valid && this.selected.CoverageGroups.length > 0;
      }
      return valid && this.validPayloadOptions();
    },
    validPayloadOptions() {
      let valid = false;
      for (const item of this.payload.Options) {
        switch (this.selectedReport) {
          case "Premiums":
            valid =
              item.IncludeMemberDetails ||
              item.IncludeGroupSummary ||
              item.IncludeTotal;
            break;
          case "Billing":
            if (item.EmployerId) {
              valid = item.EmployerHasStores
                ? item.IncludeTotal
                : item.IncludeMemberDetails || item.IncludeGroupSummary;
            } else if (item.StoreId) {
              valid = item.IncludeMemberDetails || item.IncludeGroupSummary;
            } else {
              valid = false;
            }
            break;
          case "Billing Enhanced":
            if (item.EmployerId) {
              valid = item.EmployerHasStores
                ? item.IncludeTotal
                : item.IncludeMemberDetails || item.IncludeGroupSummary;
            } else if (item.StoreId) {
              valid = item.IncludeMemberDetails || item.IncludeGroupSummary;
            } else {
              valid = false;
            }
            break;
          case "Remittances":
            valid =
              item.IncludeMemberDetails ||
              item.IncludeGroupSummary ||
              item.IncludeTotal;
            break;
          case "Commissions":
            valid =
              this.payload.IncludeCommissionTotal ||
              item.IncludeCommissionSummary ||
              item.IncludeCommissionDetails ||
              item.IncludeFlatFees;
            break;
          case "Commissions Enhanced":
            valid =
              this.payload.IncludeCommissionTotal ||
              item.IncludeCommissionSummary ||
              item.IncludeCommissionDetails ||
              item.IncludeFlatFees;
            break;
          case "Commissions Recap Enhanced":
            valid =
              this.payload.IncludeCommissionTotal ||
              item.IncludeCommissionSummary ||
              item.IncludeCommissionDetails ||
              item.IncludeFlatFees;
            break;
        }
        if (valid) {
          break;
        }
      }
      return valid;
    },
    getReportsSelections() {
      switch (this.selectedReport) {
        case "Premiums":
          return this.selected.InsuranceCarriers;
        case "Billing":
          return this.selected.Employers;
        case "Billing Enhanced":
          return this.selected.Employers;
        case "Remittances":
          return this.selected.TrustFunds;
        case "Commissions":
          return this.selected.Brokers;
        case "Commissions Enhanced":
          return this.selected.Brokers;
        case "Commissions Recap Enhanced":
          return this.selected.Brokers;
      }
    },
    downloadBlob(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      link.setAttribute("id", "link1");
      document.body.appendChild(link);
      link.click();
      var element = document.getElementById("link1");
      element.parentNode.removeChild(element);
    },
    async downloadPdf() {
      try {
        const response = await this.fetchFile({
          url: this.settings.APIURL + "pdfs/" + this.file.PDFName,
          filename: this.file.PDFName,
        });
        this.downloadBlob(new Blob([response.data]), this.file.PDFName);
      } catch (e) {
        console.error(e);
      }
    },
    async downloadExcel() {
      try {
        var response = await this.fetchFile({
          url: this.settings.APIURL + "excels/" + this.file.ExcelName,
          filename: this.file.ExcelName,
        });
        this.downloadBlob(new Blob([response.data]), this.file.ExcelName);
      } catch (e) {
        console.error(e);
      }
    },
    async getCoverageGroups() {
      this.selected.CoverageGroups = [];
      if (this.selectedReport === "Premiums") {
        if (
          this.selected.InsuranceCarriers &&
          this.selected.InsuranceCarriers.length > 0
        ) {
          this.coverageGroups = (
            await this.getInsuranceCarrierCoverageGroups({
              planId: this.selectedPlan.Id,
              reportId: this.reportId,
              insuranceCarrierIds: this.selected.InsuranceCarriers.map(
                (o) => o.Id
              ),
            })
          ).data;
        } else {
          this.coverageGroups = [];
        }
      } else if (this.selectedReport === "Billing") {
        this.coverageGroups = (
          await this.getPlanCoverageGroups({
            planId: this.selectedPlan.Id,
            reportId: this.reportId,
          })
        ).data;
      } else if (this.selectedReport === "Billing Enhanced") {
        this.coverageGroups = (
          await this.getPlanCoverageGroups({
            planId: this.selectedPlan.Id,
            reportId: this.reportId,
          })
        ).data;
      } else if (this.selectedReport === "Remittances") {
        this.coverageGroups = (
          await this.getTrustfundCoverageGroups({
            planId: this.selectedPlan.Id,
            reportId: this.reportId,
          })
        ).data;
      }
    },
  },
};
</script>

<style>
table.report-options td {
  padding: 10px;
}
</style>
